import React, { memo } from 'react'
import * as Styled from './styled'
import { ReactComponent as EmailIcon } from '../../../../assets/svgs/email.svg'
import { ReactComponent as PhoneIcon } from '../../../../assets/svgs/telefone.svg'
import PropTypes from 'prop-types';

const ContactItem = ({icon, title, description, link}) => {

    const getProps = () => ({
      'aria-label': icon,
      alt: icon,
      style: { gridArea: 'icon' },
    })

  
  return (
  <Styled.Wrapper icon={icon}>
    {icon === 'email' && <EmailIcon {...getProps()}/>}
    {icon === 'telefone' && <PhoneIcon {...getProps()}/>}
    <Styled.Title>{title}</Styled.Title>
    <Styled.Description rel="noopener noreferrer" href={link}>{description}</Styled.Description>
  </Styled.Wrapper>
  )
}

ContactItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string,
};

export default memo(ContactItem)
